import React, { useContext } from "react";
import "./Intro.css";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import sanjay from '../../img/sanjay.png'
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "Zoom" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Hi! I Am</span>
          <span>Sanjay Kumar Yadav</span>
          <span>
          Based in Kathmandu, Nepal, I work as a front-end developer. For websites for business corporations, news portals, and e-commerce, I have created a wide variety of front-ends.
          I have a strong interest for modern, pixel-perfect, stunning interfaces and intuitively executed UX.
          </span>
        </div>
        <Link to="contact" smooth={true} spy={true}>
          <button className="button i-button">Hire me</button>
        </Link>
        {/* social icons */}
        <div className="i-icons">
        <div className="f-icons">
          <td
            onClick={() =>
              window.open(
                "https://www.facebook.com/sanjaykumar.sanjaykumar.7547",
                "_blank"
              )
            }
          >
            <Facebook color="blue" size={"3rem"} />
          </td>
          <td
            onClick={() =>
              window.open(
                "https://instagram.com/messsanjay?igshid=YmMyMTA2M2Y="
              )
            }
          >
            <Insta color="red" size={"3rem"} />
          </td>
          <td
            onClick={() =>
              window.open("https://github.com/sanjaykumar49319", "_blank")
            }
          >
            <Gitub color="grey" size={"3rem"} />
          </td>
        </div>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
      
        <img src={sanjay} alt="" />
        {/* animation */}
        <motion.img
          initial={{ left: "-36%" }}
          whileInView={{ left: "-4%" }}
          transition={transition}
          src={glassesimoji}
          alt=""
        />

        <motion.div
          initial={{ top: "-3%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Web" text2="Developer" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Over 50 + " text2="Websites" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
